import React from 'react';

import { Money } from '../../../components';

const PriceEvolutionView = ({ analytics }) => {
  if (!analytics?.evolution) {
    return 'N/A';
  }

  const up = analytics?.evolution > 0;
  const down = analytics?.evolution < 0;

  const evolution = Math.abs(parseInt(analytics?.evolution));
  const price = parseInt(
    Math.abs(analytics?.retail_price * analytics?.evolution) / 100
  );

  let className = 'price-evolution';
  if (up) {
    className += ' price-up';
  }
  if (down) {
    className += ' price-down';
  }

  return (
    <span className={className}>
      {up && '+'}
      {down && '-'}
      &nbsp;
      {evolution}%
      &nbsp;
      /
      &nbsp;
      {up && '+'}
      {down && '-'}
      &nbsp;
      {/* Analytics magnitudes are the GBP pivot — explicit GBP. */}
      <Money amount={price} currency="gbp" style={{ fontFamily: 'Calibri Bold' }} />
    </span>
  );
}

export default PriceEvolutionView;
